// Üretimde backend aynı origin'den nginx reverse proxy ile sunuluyor, bu yüzden boş
// (relative) taban URL kullanılıyor — hangi domain'e deploy edilirse edilsin otomatik doğru
// çalışır, hardcoded bir production domaini olmasına gerek kalmaz.
export const API_BASE_URL = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8000';
const DEFAULT_BASE_URL = API_BASE_URL;

function getToken() {
  const t = localStorage.getItem('token') || localStorage.getItem('access_token');
  if (!t) return null;
  const s = String(t).trim();
  return s ? s : null;
}

export async function apiFetch(path, options = {}) {
  const baseUrl = options.baseUrl || DEFAULT_BASE_URL;
  const url = path.startsWith('http')
    ? path
    : `${baseUrl}${path.startsWith('/') ? '' : '/'}${path}`;

  const headers = new Headers(options.headers || {});

  const token = getToken();
  if (token && !headers.has('Authorization')) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  return fetch(url, {
    ...options,
    headers,
  });
}

export async function apiJson(path, options = {}) {
  const resp = await apiFetch(path, options);
  const ct = resp.headers.get('content-type') || '';
  const isJson = ct.includes('application/json');
  const data = isJson ? await resp.json() : await resp.text();

  if (!resp.ok) {
    const detail = (data && data.detail)
      ? data.detail
      : (typeof data === 'string' ? data : 'Request failed');
    const err = new Error(detail);
    err.status = resp.status;
    err.data = data;
    throw err;
  }

  return data;
}
